import React, { useEffect, useState, createElement } from 'react';
import { Check, X, ChevronDown, ChevronUp, ArrowRight, Star, Smartphone, XIcon, Flame, ShieldCheck, Lock, RotateCcw, BookOpen, Coffee, Calculator, MessageCircle, Gift, Calendar, Camera, AlertTriangle } from 'lucide-react';
const CTAButton = ({
  children,
  className = '',
  href = 'https://www.cocinandoconjoha.com/cart/47735075963045:1',
  external = true
}: {
  children: React.ReactNode;
  className?: string;
  href?: string;
  external?: boolean;
}) => <a href={href} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} onClick={() => {
  if (external && typeof window !== 'undefined' && (window as any).fbq) {
    ;
    (window as any).fbq('track', 'AddToCart', {
      content_name: 'El Paso a Paso del Medio Millón',
      content_type: 'product',
      value: 8690,
      currency: 'ARS'
    });
  }
}} className={`relative w-full md:w-auto bg-gold hover:bg-gold-hover text-white font-extrabold py-5 px-10 rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1.5 hover:scale-105 flex items-center justify-center gap-3 text-xl tracking-wide animate-cta-pulse no-underline ${className}`} data-id="element-0">
    {children}
    <ArrowRight className="w-6 h-6" data-id="element-1" />
  </a>;
const Divider = () => <div className="flex justify-center py-12" data-id="element-2">
    <div className="w-24 h-[1px] bg-gold/40" data-id="element-3"></div>
  </div>;
export function App() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  const [modal, setModal] = useState<'privacy' | 'terms' | null>(null);
  const [bump1, setBump1] = useState(false);
  const [bump2, setBump2] = useState(false);
  const basePrice = 8690;
  const bump1Price = 10500;
  const bump2Price = 10900;
  const totalPrice = basePrice + (bump1 ? bump1Price : 0) + (bump2 ? bump2Price : 0);
  const formatPrice = (n: number) => n.toLocaleString('es-AR');
  const getCheckoutUrl = () => {
    if (bump1 && bump2) return 'https://cocinandoconjoha.com/cart/47765826076837:1';
    if (bump1) return 'https://cocinandoconjoha.com/cart/47765811724453:1';
    if (bump2) return 'https://cocinandoconjoha.com/cart/47765829615781:1';
    return 'https://www.cocinandoconjoha.com/cart/47735075963045:1';
  };
  useEffect(() => {
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n: any = f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      f.fbq('init', '1279876863600581');
      f.fbq('track', 'PageView');
    }
  }, []);
  const faqs = [{
    q: '¿Necesito horno?',
    a: 'No. La mayoría de los postres son fríos y se ensamblan en capas. Solo necesitás heladera y vasos descartables.'
  }, {
    q: '¿Cuánta plata necesito para empezar?',
    a: 'Con $3.000–$5.000 de insumos podés armar tus primeros 10 vasos y recuperar la inversión más que de sobra en tu primera venta.'
  }, {
    q: '¿Tengo que saber decorar o tener conocimientos de repostería?',
    a: 'No. Las recetas están escritas para alguien que nunca cocinó nada. Si podés seguir instrucciones paso a paso, podés hacer esto.'
  }, {
    q: '¿Sirve para todo el país?',
    a: 'Sí. La guía incluye la Calculadora de Costos que se adapta a los precios de tu zona, ya sea Buenos Aires, Córdoba, Rosario o cualquier provincia.'
  }, {
    q: '¿Cómo recibo la guía?',
    a: 'Inmediatamente después del pago recibís el link de descarga en tu email. En menos de 2 minutos lo tenés en tu teléfono.'
  }, {
    q: '¿Y si no me funciona?',
    a: 'Tenés 7 días de garantía total. Si no recuperás lo invertido, te devolvemos el dinero sin preguntas.'
  }];
  return <div className="min-h-screen bg-cream selection:bg-gold/30 selection:text-white" data-id="element-4">
      {/* BLOQUE 1 — HERO */}
      <header className="pt-16 pb-12 md:pt-24 md:pb-16 px-4 max-w-6xl mx-auto" data-id="element-5">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-6">
          <div className="flex-1 text-center lg:text-left" data-id="element-7">
            <div className="inline-flex items-center gap-2 bg-red-100 text-red-700 px-4 py-1.5 rounded-full text-sm font-bold tracking-wide mb-6 shadow-sm border border-red-200" data-id="element-8">
              <Flame className="w-4 h-4" data-id="element-9" /> +847 emprendedores ya empezaron esta
              semana
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-10">
              El sistema para facturar tu primer sueldo extra vendiendo postres
              en vasos desde casa.{' '}
              <span className="text-gold" data-id="element-11">
                Sin horno. Sin redes. Sin excusas.
              </span>
            </h1>
            <h2 className="text-xl md:text-2xl text-warm-dark font-medium leading-relaxed mb-8" data-id="element-12">
              El sistema de Postres en Vaso que está llenando cocinas argentinas
              de pedidos reales por WhatsApp.
            </h2>
            <CTAButton href="#oferta" external={false} data-id="element-13">
              ¡QUIERO MI GUÍA AHORA!
            </CTAButton>
            <p className="mt-4 text-sm text-warm-dark/70 font-medium" data-id="element-14">
              Acceso inmediato. Empezás a vender hoy mismo.
            </p>

            <div className="mt-8 bg-white/60 p-4 rounded-xl border border-gold/20 inline-block text-left" data-id="element-15">
              <div className="flex gap-1 mb-2" data-id="element-16">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 star-gold" data-id="element-17" />)}
              </div>
              <p className="text-warm-dark italic font-medium" data-id="element-18">
                "Hice mis primeros $80.000 en 4 días"
              </p>
              <p className="text-sm text-warm-dark/70 mt-1" data-id="element-19">
                — Romina, Córdoba
              </p>
            </div>
          </div>
          <div className="flex-1 relative w-full max-w-lg mx-auto lg:max-w-none" data-id="element-20">
            <div className="absolute inset-0 bg-gold/20 rounded-full blur-3xl transform scale-90 -z-10" data-id="element-21"></div>
            <img src="https://cdn.magicpatterns.com/uploads/gWojS3YoiJiDdax4bHWMvy/NUEVO_PRODUCTO.png" alt="Ebook El Pack de los 500K en tablet y celular con postres en vaso" className="w-full h-auto drop-shadow-2xl rounded-xl" data-id="element-22" />
          </div>
        </div>
      </header>

      <Divider data-id="element-23" />

      {/* BLOQUE 2 — AGITACIÓN DEL DOLOR */}
      <section className="py-16 px-4 max-w-5xl mx-auto" data-id="element-24">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-25">
          ¿Te suena familiar alguna de estas situaciones?
        </h2>
        <div className="grid md:grid-cols-2 gap-6 mb-10" data-id="element-26">
          {['Cocinás horas y al final ganás menos que en cualquier trabajo en relación de dependencia', 'Ves a otras vendiendo postres en redes y no entendés por qué a ellas les funciona y a vos no', "Calculaste los costos 'a ojo' y después de trabajar todo el fin de semana, casi no te quedó ganancia", 'Tenés ganas de emprender pero sentís que necesitás una inversión enorme para arrancar'].map((pain, i) => <div key={i} className="bg-white p-6 rounded-2xl border border-gold/20 shadow-sm flex items-start gap-4" data-id="element-27">
              <div className="bg-red-50 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-28">
                <X className="w-5 h-5 text-red-500" data-id="element-29" />
              </div>
              <p className="text-lg text-warm-dark font-medium" data-id="element-30">{pain}</p>
            </div>)}
        </div>
        <p className="text-xl md:text-2xl text-center font-bold text-gold" data-id="element-31">
          Si dijiste sí a alguna de estas — lo que sigue es para vos.
        </p>
      </section>

      {/* BLOQUE 3 — EL MECANISMO */}
      <section className="py-20 px-4 bg-chocolate text-white" data-id="element-32">
        <div className="max-w-4xl mx-auto" data-id="element-33">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center text-gold-light" data-id="element-34">
            El error que comete el 90% de las emprendedoras de repostería
          </h2>
          <p className="text-xl text-center mb-10 opacity-90" data-id="element-35">
            Las tortas enteras son el producto más difícil de vender en
            Argentina hoy:
          </p>

          <div className="bg-white/10 rounded-2xl overflow-hidden border border-gold/30 mb-12 backdrop-blur-sm" data-id="element-36">
            <div className="overflow-x-auto" data-id="element-37">
              <table className="w-full text-left" data-id="element-38">
                <thead data-id="element-39">
                  <tr className="bg-white/5" data-id="element-40">
                    <th className="p-5 border-b border-gold/30 text-lg font-bold text-white/70 w-1/2" data-id="element-41">
                      Torta entera
                    </th>
                    <th className="p-5 border-b border-gold/30 text-lg font-bold text-gold-light w-1/2" data-id="element-42">
                      Postre en vaso
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gold/10" data-id="element-43">
                  <tr data-id="element-44">
                    <td className="p-5 text-white/80" data-id="element-45">
                      $25.000–$40.000 por unidad
                    </td>
                    <td className="p-5 font-medium text-gold-light" data-id="element-46">
                      $5.500–$8.000 por porción
                    </td>
                  </tr>
                  <tr data-id="element-47">
                    <td className="p-5 text-white/80" data-id="element-48">
                      Difícil de transportar
                    </td>
                    <td className="p-5 font-medium text-gold-light" data-id="element-49">
                      Se entrega en mano, sin problemas
                    </td>
                  </tr>
                  <tr data-id="element-50">
                    <td className="p-5 text-white/80" data-id="element-51">
                      Si no vendés en 24 hs, tirás todo
                    </td>
                    <td className="p-5 font-medium text-gold-light" data-id="element-52">
                      Dura 5 días en heladera
                    </td>
                  </tr>
                  <tr data-id="element-53">
                    <td className="p-5 text-white/80" data-id="element-54">Un cliente por venta</td>
                    <td className="p-5 font-medium text-gold-light" data-id="element-55">
                      10 clientes por la misma producción
                    </td>
                  </tr>
                  <tr data-id="element-56">
                    <td className="p-5 text-white/80" data-id="element-57">
                      Requiere horno y equipamiento
                    </td>
                    <td className="p-5 font-medium text-gold-light" data-id="element-58">
                      Solo heladera y vasos descartables
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="text-center space-y-6 max-w-3xl mx-auto" data-id="element-59">
            <h3 className="text-2xl md:text-3xl font-bold text-gold-light" data-id="element-60">
              El "Efecto Vitrina" cambia todo.
            </h3>
            <p className="text-lg leading-relaxed opacity-90" data-id="element-61">
              No se trata de cocinar mejor. Se trata de ensamblar capas de alto
              impacto visual que disparan el deseo de compra inmediato — incluso
              antes de que el cliente pregunte el precio.
            </p>
            <p className="text-lg leading-relaxed opacity-90" data-id="element-62">
              Un postre que te costó $1.800 fabricar se ve, se fotografía y se
              vende como un producto premium de $6.500.
            </p>
            <p className="text-xl font-bold text-gold-light pt-4 border-t border-gold/20" data-id="element-63">
              Eso no es magia. Es ingeniería de ventas aplicada a tu cocina.
            </p>
          </div>
        </div>
      </section>

      {/* BLOQUE 4 — PRUEBA SOCIAL */}
      <section className="py-20 px-4 bg-white/50" data-id="element-64">
        <div className="max-w-5xl mx-auto" data-id="element-65">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-66">
            Lo que dicen las que ya empezaron:
          </h2>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-67">
            {[{
            text: 'Nunca había vendido nada en mi vida. En mi primera semana hice $48.000 solo con Chocotorta en vaso y mis contactos de WhatsApp.',
            author: 'Mariela G., Buenos Aires'
          }, {
            text: 'Intenté con tortas y siempre perdía plata. Con esto entendí finalmente cómo calcular los costos y ahora sé exactamente cuánto gano por cada vaso.',
            author: 'Florencia T., Rosario'
          }, {
            text: 'Lo descargué un jueves a la noche. El sábado ya tenía 15 pedidos para el fin de semana.',
            author: 'Carla M., Mendoza'
          }].map((testimonial, i) => <div key={i} className="bg-cream p-8 rounded-2xl border border-gold/20 shadow-sm relative" data-id="element-68">
                <div className="flex gap-1 mb-4" data-id="element-69">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 star-gold" data-id="element-70" />)}
                </div>
                <p className="text-warm-dark font-medium leading-relaxed mb-6" data-id="element-71">
                  "{testimonial.text}"
                </p>
                <p className="text-sm font-bold text-chocolate" data-id="element-72">
                  — {testimonial.author}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* BLOQUE 5 — QUÉ INCLUYE (STACK DE VALOR) */}
      <section className="py-20 px-4 max-w-4xl mx-auto" data-id="element-73">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-74">
          Esto es lo que recibís con acceso inmediato:
        </h2>

        <div className="space-y-6 mb-12" data-id="element-75">
          <div className="bg-white p-6 md:p-8 rounded-2xl border-l-4 border-gold shadow-sm flex flex-col md:flex-row gap-6 items-start" data-id="element-76">
            <div className="bg-gold/10 p-4 rounded-xl flex-shrink-0" data-id="element-77">
              <BookOpen className="w-8 h-8 text-gold" data-id="element-78" />
            </div>
            <div data-id="element-79">
              <div className="mb-2" data-id="element-80">
                <h3 className="font-bold text-xl text-chocolate" data-id="element-81">
                  Guía Maestra "Postres de Oro"
                </h3>
              </div>
              <p className="text-warm-dark leading-relaxed" data-id="element-82">
                El paso a paso completo para montar tu negocio en 48 horas.
                Desde la primera compra de insumos hasta tu primer cobro.
              </p>
            </div>
          </div>

          <div className="bg-white p-6 md:p-8 rounded-2xl border-l-4 border-gold shadow-sm flex flex-col md:flex-row gap-6 items-start" data-id="element-83">
            <div className="bg-gold/10 p-4 rounded-xl flex-shrink-0" data-id="element-84">
              <Coffee className="w-8 h-8 text-gold" data-id="element-85" />
            </div>
            <div data-id="element-86">
              <div className="mb-2" data-id="element-87">
                <h3 className="font-bold text-xl text-chocolate" data-id="element-88">
                  Recetario de los 10 Intocables
                </h3>
              </div>
              <p className="text-warm-dark leading-relaxed" data-id="element-89">
                Las fórmulas exactas de Chocotorta, Oreo, Lemon Pie, Tiramisú y
                6 más. Las 10 recetas con mayor rotación de ventas en Argentina.
              </p>
            </div>
          </div>

          <div className="bg-white p-6 md:p-8 rounded-2xl border-l-4 border-gold shadow-sm flex flex-col md:flex-row gap-6 items-start" data-id="element-90">
            <div className="bg-gold/10 p-4 rounded-xl flex-shrink-0" data-id="element-91">
              <Calculator className="w-8 h-8 text-gold" data-id="element-92" />
            </div>
            <div data-id="element-93">
              <div className="mb-2" data-id="element-94">
                <h3 className="font-bold text-xl text-chocolate" data-id="element-95">
                  Guía de Costos Argentina
                </h3>
              </div>
            </div>
          </div>

          <div className="bg-white p-6 md:p-8 rounded-2xl border-l-4 border-gold shadow-sm flex flex-col md:flex-row gap-6 items-start" data-id="element-96">
            <div className="bg-gold/10 p-4 rounded-xl flex-shrink-0" data-id="element-97">
              <MessageCircle className="w-8 h-8 text-gold" data-id="element-98" />
            </div>
            <div data-id="element-99">
              <div className="mb-2" data-id="element-100">
                <h3 className="font-bold text-xl text-chocolate" data-id="element-101">
                  Estrategia Venta Flash por WhatsApp
                </h3>
              </div>
              <p className="text-warm-dark leading-relaxed" data-id="element-102">
                El mensaje exacto (copiá y pegá) que agota tu stock en 24 horas
                usando solo tus contactos. Sin seguidores, sin redes, sin
                publicidad.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-gold/10 border border-gold/30 rounded-2xl p-8 text-center" data-id="element-103">
          <p className="text-3xl md:text-4xl font-bold text-chocolate mb-8" data-id="element-104">
            Y TAMBIÉN PREPARAMOS ALGO ESPECIAL
          </p>
          <CTAButton href="#oferta" external={false} className="mx-auto" data-id="element-105">
            QUIERO ACCESO INMEDIATO
          </CTAButton>
        </div>
      </section>

      {/* NUEVO BLOQUE — STACK DE BONOS */}
      <section className="py-20 px-4 bg-chocolate text-white" data-id="element-106">
        <div className="max-w-5xl mx-auto" data-id="element-107">
          {/* INTRO */}
          <div className="text-center mb-16" data-id="element-108">
            <div className="inline-flex items-center gap-2 bg-black/30 px-6 py-3 rounded-full text-lg font-bold tracking-wide mb-8 border border-yellow-500/40 shadow-lg shadow-yellow-500/10" data-id="element-109">
              <Gift className="w-6 h-6 text-yellow-400" data-id="element-110" />
              <span className="gold-shimmer-badge text-lg" data-id="element-111">
                BONOS EXCLUSIVOS — SOLO EN ESTE LANZAMIENTO
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gold-light leading-tight" data-id="element-112">
              3 BONOS GRATIS
            </h2>
          </div>

          {/* BONO 1 */}
          <div className="bg-white/5 border border-gold/20 rounded-3xl p-8 md:p-10 mb-10 backdrop-blur-sm" data-id="element-113">
            <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-114">
              <div data-id="element-115">
                <div className="inline-flex items-center gap-2 gold-shimmer-bg text-chocolate px-4 py-1.5 rounded-full text-sm font-bold tracking-wide mb-4" data-id="element-116">
                  <Gift className="w-4 h-4" data-id="element-117" /> BONO #1 — GRATIS HOY
                </div>
                <h3 className="text-2xl font-bold text-gold-light mb-2" data-id="element-118">
                  PLAN 5 DÍAS PARA TU PRIMER COBRO
                </h3>
                <p className="text-lg mb-6 opacity-90" data-id="element-119">
                  De "quiero empezar" a "ya cobré" en menos de una semana.
                </p>
                <ul className="space-y-2 mb-6" data-id="element-120">
                  {['Mapa exacto de 5 días para arrancar sin trabarte', 'Una sola acción por día — sin abrumarte', 'Checklist diaria + tracker de avance', 'Hoja resumen printable'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-121">
                      <Check className="w-5 h-5 text-yellow-400 flex-shrink-0 mt-0.5" data-id="element-122" />
                      <span className="text-white/90 text-sm" data-id="element-123">{item}</span>
                    </li>)}
                </ul>
                <div className="flex items-center gap-4 mb-4" data-id="element-124">
                  <span className="line-through text-white/40" data-id="element-125">USD 47</span>
                  <span className="font-bold text-yellow-400 text-xl" data-id="element-126">
                    GRATIS
                  </span>
                </div>
                <CTAButton href="#oferta" external={false} className="w-full text-base py-4" data-id="element-127">
                  Quiero el plan de 5 días gratis con mi pack
                </CTAButton>
              </div>
              <div className="order-first md:order-last" data-id="element-128">
                <img src="https://cdn.magicpatterns.com/uploads/2MK8PRMYHCd9JWtSbFGByV/Bono_1.jpg" alt="Plan de 5 días" className="w-full rounded-2xl shadow-2xl border border-gold/20" data-id="element-129" />
              </div>
            </div>
          </div>

          {/* BONO 2 */}
          <div className="bg-white/5 border border-gold/20 rounded-3xl p-8 md:p-10 mb-10 backdrop-blur-sm" data-id="element-130">
            <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-131">
              <div data-id="element-132">
                <img src="https://cdn.magicpatterns.com/uploads/sr3fNBxnWJPUVM9dRnrJu7/Bono_2.jpg" alt="15 Mensajes para WhatsApp" className="w-full rounded-2xl shadow-2xl border border-gold/20" data-id="element-133" />
              </div>
              <div data-id="element-134">
                <div className="inline-flex items-center gap-2 gold-shimmer-bg text-chocolate px-4 py-1.5 rounded-full text-sm font-bold tracking-wide mb-4" data-id="element-135">
                  <Gift className="w-4 h-4" data-id="element-136" /> BONO #2 — GRATIS HOY
                </div>
                <h3 className="text-2xl font-bold text-gold-light mb-2" data-id="element-137">
                  15 MENSAJES LISTOS PARA VENDER POR WHATSAPP
                </h3>
                <p className="text-lg mb-6 opacity-90" data-id="element-138">
                  Copiá, pegá y activá pedidos sin pensar qué decir.
                </p>
                <ul className="space-y-2 mb-6" data-id="element-139">
                  {['5 scripts para Estados que generan antojo', '5 mensajes para contactos cercanos sin sonar pesada', '3 mensajes para cerrar pedidos al instante', '2 mensajes para reactivar interés', 'Plantilla editable para crear cualquier mensaje'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-140">
                      <Check className="w-5 h-5 text-yellow-400 flex-shrink-0 mt-0.5" data-id="element-141" />
                      <span className="text-white/90 text-sm" data-id="element-142">{item}</span>
                    </li>)}
                </ul>
                <div className="flex items-center gap-4 mb-4" data-id="element-143">
                  <span className="line-through text-white/40" data-id="element-144">USD 47</span>
                  <span className="font-bold text-yellow-400 text-xl" data-id="element-145">
                    GRATIS
                  </span>
                </div>
                <CTAButton href="#oferta" external={false} className="w-full text-base py-4" data-id="element-146">
                  Quiero los 15 mensajes gratis con mi pack
                </CTAButton>
              </div>
            </div>
          </div>

          {/* BONO 3 */}
          <div className="bg-white/5 border border-gold/20 rounded-3xl p-8 md:p-10 mb-16 backdrop-blur-sm" data-id="element-147">
            <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-148">
              <div data-id="element-149">
                <div className="inline-flex items-center gap-2 gold-shimmer-bg text-chocolate px-4 py-1.5 rounded-full text-sm font-bold tracking-wide mb-4" data-id="element-150">
                  <Gift className="w-4 h-4" data-id="element-151" /> BONO #3 — GRATIS HOY
                </div>
                <h3 className="text-2xl font-bold text-gold-light mb-2" data-id="element-152">
                  CHECKLIST DE FOTO QUE HACE QUE SE ANTOJEN
                </h3>
                <p className="text-lg mb-6 opacity-90" data-id="element-153">
                  Hacé que tus postres se vean irresistibles usando solo tu
                  celular.
                </p>
                <ul className="space-y-2 mb-6" data-id="element-154">
                  {['Los 7 tipos de foto que siempre tenés que tener', 'Fórmula visual para que se vean premium', 'Errores comunes que hacen vender menos', 'Checklist express antes de publicar'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-155">
                      <Check className="w-5 h-5 text-yellow-400 flex-shrink-0 mt-0.5" data-id="element-156" />
                      <span className="text-white/90 text-sm" data-id="element-157">{item}</span>
                    </li>)}
                </ul>
                <div className="flex items-center gap-4 mb-4" data-id="element-158">
                  <span className="line-through text-white/40" data-id="element-159">USD 47</span>
                  <span className="font-bold text-yellow-400 text-xl" data-id="element-160">
                    GRATIS
                  </span>
                </div>
                <CTAButton href="#oferta" external={false} className="w-full text-base py-4" data-id="element-161">
                  Quiero la checklist de fotos gratis con mi pack
                </CTAButton>
              </div>
              <div className="order-first md:order-last" data-id="element-162">
                <img src="https://cdn.magicpatterns.com/uploads/aAntB4gSZVNXbHPYjdJGRD/Bono_3.jpg" alt="Checklist de Fotos" className="w-full rounded-2xl shadow-2xl border border-gold/20" data-id="element-163" />
              </div>
            </div>
          </div>

          {/* RESUMEN */}
          <div className="max-w-4xl mx-auto mb-16" data-id="element-164">
            <h2 className="text-3xl font-bold text-center mb-8 text-gold-light" data-id="element-165">
              Todo lo que recibís hoy
            </h2>
            <div className="space-y-4 mb-8" data-id="element-166">
              <div className="bg-white/10 rounded-2xl border border-gold/30 p-4 flex items-center gap-4" data-id="element-167">
                <img src="https://cdn.magicpatterns.com/uploads/gWojS3YoiJiDdax4bHWMvy/NUEVO_PRODUCTO.png" alt="Pack Principal" className="w-16 h-16 md:w-20 md:h-20 rounded-xl object-cover border border-gold/20 flex-shrink-0" data-id="element-168" />
                <div className="flex-1 min-w-0" data-id="element-169">
                  <p className="text-white font-bold text-lg truncate" data-id="element-170">
                    Pack Principal — Ebook PDF
                  </p>
                  <p className="text-white/60 text-sm" data-id="element-171">
                    El Paso a Paso del Medio Millón
                  </p>
                </div>
                <span className="text-white/80 font-medium text-right flex-shrink-0" data-id="element-172">
                  $25.000 ARS
                </span>
              </div>
              <div className="bg-white/10 rounded-2xl border border-gold/30 p-4 flex items-center gap-4" data-id="element-173">
                <img src="https://cdn.magicpatterns.com/uploads/2MK8PRMYHCd9JWtSbFGByV/Bono_1.jpg" alt="Bono 1" className="w-16 h-16 md:w-20 md:h-20 rounded-xl object-cover border border-gold/20 flex-shrink-0" data-id="element-174" />
                <div className="flex-1 min-w-0" data-id="element-175">
                  <p className="text-white font-bold text-lg truncate" data-id="element-176">
                    Bono 1 — Plan 5 Días
                  </p>
                  <p className="text-white/60 text-sm" data-id="element-177">Para tu primer cobro</p>
                </div>
                <span className="text-yellow-400 font-bold text-right flex-shrink-0" data-id="element-178">
                  GRATIS
                </span>
              </div>
              <div className="bg-white/10 rounded-2xl border border-gold/30 p-4 flex items-center gap-4" data-id="element-179">
                <img src="https://cdn.magicpatterns.com/uploads/sr3fNBxnWJPUVM9dRnrJu7/Bono_2.jpg" alt="Bono 2" className="w-16 h-16 md:w-20 md:h-20 rounded-xl object-cover border border-gold/20 flex-shrink-0" data-id="element-180" />
                <div className="flex-1 min-w-0" data-id="element-181">
                  <p className="text-white font-bold text-lg truncate" data-id="element-182">
                    Bono 2 — 15 Mensajes WhatsApp (PDF)
                  </p>
                  <p className="text-white/60 text-sm" data-id="element-183">Copiá, pegá y vendé</p>
                </div>
                <span className="text-yellow-400 font-bold text-right flex-shrink-0" data-id="element-184">
                  GRATIS
                </span>
              </div>
              <div className="bg-white/10 rounded-2xl border border-gold/30 p-4 flex items-center gap-4" data-id="element-185">
                <img src="https://cdn.magicpatterns.com/uploads/aAntB4gSZVNXbHPYjdJGRD/Bono_3.jpg" alt="Bono 3" className="w-16 h-16 md:w-20 md:h-20 rounded-xl object-cover border border-gold/20 flex-shrink-0" data-id="element-186" />
                <div className="flex-1 min-w-0" data-id="element-187">
                  <p className="text-white font-bold text-lg truncate" data-id="element-188">
                    Bono 3 — Checklist de Fotos (PDF)
                  </p>
                  <p className="text-white/60 text-sm" data-id="element-189">
                    Fotos que generan antojo
                  </p>
                </div>
                <span className="text-yellow-400 font-bold text-right flex-shrink-0" data-id="element-190">
                  GRATIS
                </span>
              </div>
              <div className="gold-shimmer-bg rounded-2xl p-5 flex items-center justify-between" data-id="element-191">
                <span className="font-bold text-chocolate text-lg" data-id="element-192">
                  Hoy lo llevás todo por
                </span>
                <span className="font-bold text-chocolate text-2xl" data-id="element-193">
                  $8.690 ARS
                </span>
              </div>
            </div>
            <p className="text-center text-lg font-bold text-gold-light" data-id="element-194">
              Todo lo que necesitás para empezar a cobrar esta semana está acá.
            </p>
          </div>

          {/* CTA FINAL */}
          <div className="max-w-3xl mx-auto text-center" data-id="element-195">
            <div className="inline-flex items-center gap-2 bg-red-500/20 text-red-300 px-5 py-2.5 rounded-xl font-bold mb-8 border border-red-500/30 text-sm" data-id="element-196">
              <AlertTriangle className="w-5 h-5 flex-shrink-0" data-id="element-197" />
              <span data-id="element-198">Los bonos solo están disponibles en este lanzamiento.</span>
            </div>

            <h2 className="text-3xl md:text-4xl font-bold mb-8 text-gold-light" data-id="element-199">
              ¿Cuánto más vas a esperar para empezar a cobrar desde tu cocina?
            </h2>

            <CTAButton href="https://www.cocinandoconjoha.com/cart/47735075963045:1" external={true} className="w-full md:w-auto mx-auto text-xl py-6 px-12 mb-6" data-id="element-200">
              ¡QUIERO EL PACK CON LOS 3 BONOS GRATIS!
            </CTAButton>

            <div className="flex flex-wrap justify-center gap-4 text-sm opacity-80 mt-4" data-id="element-201">
              <div className="flex items-center gap-2" data-id="element-202">
                <Lock className="w-4 h-4" data-id="element-203" /> Pago seguro
              </div>
              <div className="flex items-center gap-2" data-id="element-204">
                <Smartphone className="w-4 h-4" data-id="element-205" /> Acceso instantáneo
              </div>
              <div className="flex items-center gap-2" data-id="element-206">
                <RotateCcw className="w-4 h-4" data-id="element-207" /> Garantía 7 días
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* BLOQUE 6 — CÓMO FUNCIONA */}
      <section className="py-20 px-4 bg-white/50" data-id="element-208">
        <div className="max-w-5xl mx-auto" data-id="element-209">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-210">
            De cero a tu primer cobro en 3 pasos:
          </h2>
          <div className="grid md:grid-cols-3 gap-10 relative" data-id="element-211">
            <div className="hidden md:block absolute top-8 left-[15%] right-[15%] h-[2px] bg-gold/20 -z-10" data-id="element-212"></div>

            <div className="bg-cream p-8 rounded-2xl border border-gold/10 text-center relative shadow-sm" data-id="element-213">
              <div className="w-16 h-16 mx-auto bg-gold text-white rounded-full flex items-center justify-center text-2xl font-bold mb-6 shadow-lg absolute -top-8 left-1/2 transform -translate-x-1/2 border-4 border-cream" data-id="element-214">
                1
              </div>
              <h3 className="text-xl font-bold mb-4 mt-4 text-chocolate" data-id="element-215">
                Descargás
              </h3>
              <p className="text-warm-dark" data-id="element-216">
                PDF instantáneo en tu teléfono. Lo abrís y elegís 2 de las 10
                recetas maestras según los ingredientes que ya tenés en casa.
              </p>
            </div>

            <div className="bg-cream p-8 rounded-2xl border border-gold/10 text-center relative shadow-sm" data-id="element-217">
              <div className="w-16 h-16 mx-auto bg-gold text-white rounded-full flex items-center justify-center text-2xl font-bold mb-6 shadow-lg absolute -top-8 left-1/2 transform -translate-x-1/2 border-4 border-cream" data-id="element-218">
                2
              </div>
              <h3 className="text-xl font-bold mb-4 mt-4 text-chocolate" data-id="element-219">
                Armás
              </h3>
              <p className="text-warm-dark" data-id="element-220">
                Seguís la guía de ensamblado paso a paso. Sin horno. Sin técnica
                especial. En 2 horas tenés tus primeros 10 vasos listos.
              </p>
            </div>

            <div className="bg-cream p-8 rounded-2xl border border-gold/10 text-center relative shadow-sm" data-id="element-221">
              <div className="w-16 h-16 mx-auto bg-gold text-white rounded-full flex items-center justify-center text-2xl font-bold mb-6 shadow-lg absolute -top-8 left-1/2 transform -translate-x-1/2 border-4 border-cream" data-id="element-222">
                3
              </div>
              <h3 className="text-xl font-bold mb-4 mt-4 text-chocolate" data-id="element-223">
                Cobrás
              </h3>
              <p className="text-warm-dark" data-id="element-224">
                Copiás el mensaje de Venta Flash, lo mandás a tus contactos de
                WhatsApp y empezás a recibir pedidos. El primer cobro puede ser
                hoy mismo.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BLOQUE 7 — PARA QUIÉN ES / NO ES */}
      <section className="py-20 px-4 max-w-5xl mx-auto" data-id="element-225">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-226">
          <div className="bg-white p-8 rounded-2xl border-t-8 border-green-500 shadow-md" data-id="element-227">
            <h3 className="text-2xl font-bold mb-6 text-chocolate" data-id="element-228">
              Esto ES para vos si:
            </h3>
            <ul className="space-y-4" data-id="element-229">
              {['Necesitás generar dinero extra urgente desde tu casa', 'Sos mamá y querés trabajar sin descuidar a tus hijos', 'Ya cocinás pero no lográs que tu negocio sea rentable', 'No sabés nada de cocina pero podés seguir instrucciones simples'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-230">
                  <Check className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-231" />
                  <span className="text-warm-dark font-medium" data-id="element-232">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-white p-8 rounded-2xl border-t-8 border-red-500 shadow-md" data-id="element-233">
            <h3 className="text-2xl font-bold mb-6 text-chocolate" data-id="element-234">
              Esto NO es para vos si:
            </h3>
            <ul className="space-y-4" data-id="element-235">
              {['Buscás dinero fácil sin hacer nada', 'Sos repostero profesional buscando alta cocina', 'No estás dispuesta a mandar una sola foto por WhatsApp'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-236">
                  <X className="w-6 h-6 text-red-500 flex-shrink-0" data-id="element-237" />
                  <span className="text-warm-dark font-medium" data-id="element-238">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* BLOQUE 8 — GARANTÍA */}
      <section className="py-16 px-4 bg-gold/10 border-y border-gold/20" data-id="element-239">
        <div className="max-w-3xl mx-auto text-center flex flex-col items-center" data-id="element-240">
          <div className="w-20 h-20 bg-gold rounded-full flex items-center justify-center mb-6 shadow-lg" data-id="element-241">
            <ShieldCheck className="w-10 h-10 text-white" data-id="element-242" />
          </div>
          <h2 className="text-3xl font-bold text-chocolate mb-4" data-id="element-243">
            Garantía de 7 días sin preguntas
          </h2>
          <p className="text-xl text-warm-dark leading-relaxed mb-4" data-id="element-244">
            Si descargás la guía, seguís el sistema y no recuperás el valor de
            tu inversión en tu primera semana de ventas — te devolvemos el 100%
            de tu dinero. Sin burocracia, sin explicaciones.
          </p>
          <p className="text-xl font-bold text-gold" data-id="element-245">
            El riesgo es nuestro, no tuyo.
          </p>
        </div>
      </section>

      {/* BLOQUE 9 — PRECIO + CTA FINAL */}
      <section id="oferta" className="py-20 px-4 bg-chocolate text-white text-center scroll-mt-8" data-id="element-246">
        <div className="max-w-3xl mx-auto" data-id="element-247">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-gold-light" data-id="element-248">
            Tu oportunidad empieza hoy
          </h2>

          <div className="bg-white/5 border border-gold/30 rounded-3xl p-8 md:p-12 backdrop-blur-sm shadow-2xl relative overflow-hidden" data-id="element-249">
            <div className="absolute top-0 left-0 w-full bg-red-600 text-white py-2 font-bold text-sm tracking-wider animate-pulse" data-id="element-250">
              ⏰ Este precio se mantiene solo hasta agotar los primeros 100
              accesos de este lanzamiento.
            </div>

            <div className="mt-8 mb-8" data-id="element-251">
              <div className="inline-block bg-gold text-white font-serif px-10 py-6 rounded-2xl shadow-lg transform hover:scale-105 transition-transform" data-id="element-252">
                <span className="text-2xl md:text-3xl text-white/60 line-through block mb-2" data-id="element-253">
                  $25.000
                </span>
                <span className="text-5xl md:text-7xl font-bold transition-all duration-300" data-id="element-254">
                  ${formatPrice(totalPrice)} ARS
                </span>
                {(bump1 || bump2) && <span className="block text-sm mt-2 text-white/80 font-sans font-medium" data-id="element-255">
                    Pack ${formatPrice(basePrice)}
                    {bump1 ? ` + Calculadora $${formatPrice(bump1Price)}` : ''}
                    {bump2 ? ` + Kit Marketing $${formatPrice(bump2Price)}` : ''}
                  </span>}
              </div>
            </div>

            <p className="text-xl opacity-90 mb-10 max-w-xl mx-auto font-medium" data-id="element-256">
              4 Ebooks PDF (Pack + 3 Bonos Gratis) — menos de lo que cuesta una
              pizza con delivery, con el potencial de generarte $500.000 al mes.
            </p>

            <CTAButton className="w-full md:w-auto mx-auto text-xl py-6 px-12 mb-6" data-id="element-257">
              ¡QUIERO EMPEZAR MI NEGOCIO AHORA!
            </CTAButton>

            {/* ORDER BUMPS TITLE */}
            <div className="bg-gold text-white text-center font-bold text-sm md:text-base tracking-wider uppercase py-3 px-6 rounded-t-2xl mb-0" data-id="element-258">
              ⭐ Altamente Recomendado ⭐
            </div>

            {/* ORDER BUMP #1 */}
            <div onClick={() => setBump1(!bump1)} className="order-bump-flash cursor-pointer border-2 border-dashed border-gold rounded-t-none rounded-b-2xl p-5 md:p-6 mb-4 text-left bg-white/10 hover:bg-white/15 transition-colors" data-id="element-259">
              <div className="flex items-start gap-4" data-id="element-260">
                <div className={`w-6 h-6 mt-1 flex-shrink-0 rounded border-2 flex items-center justify-center transition-colors ${bump1 ? 'bg-gold border-gold' : 'border-gold-light'}`} data-id="element-261">
                  {bump1 && <Check className="w-4 h-4 text-white" data-id="element-262" />}
                </div>
                <div className="flex-1" data-id="element-263">
                  <div className="flex items-center gap-2 mb-3" data-id="element-264">
                    <Gift className="w-5 h-5 text-gold-light" data-id="element-265" />
                    <h4 className="font-bold text-base md:text-lg text-gold-light" data-id="element-266">
                      👉 ¡SÍ! AGREGAR MI CALCULADORA DE COSTOS INTELIGENTE
                      <span className="text-white ml-1" data-id="element-267">
                        (Oferta Única $10.500)
                      </span>
                    </h4>
                  </div>
                  <div className="flex flex-col md:flex-row gap-4" data-id="element-268">
                    <img src="https://cdn.magicpatterns.com/uploads/55vx62GhWFCkFJPS3scR4y/ORDER_BUMP_1.jpg" alt="Calculadora de Costos Inteligente" className="w-full md:w-36 h-auto rounded-lg object-cover flex-shrink-0" data-id="element-269" />
                    <p className="text-sm opacity-90 leading-relaxed" data-id="element-270">
                      No adivines más tus precios ni pierdas dinero por no
                      calcular el packaging o los envíos. Con esta Plantilla
                      Automatizada en Google Sheets, solo cargás el precio del
                      insumo y la herramienta te dice{' '}
                      <strong className="text-white" data-id="element-271">EXACTAMENTE</strong> cuánto
                      cobrar por cada vaso para garantizarte un{' '}
                      <strong className="text-white" data-id="element-272">
                        150% de ganancia mínima
                      </strong>
                      . Incluye video tutorial de 2 minutos para empezar a
                      usarla hoy mismo.
                    </p>
                  </div>
                  <p className="text-xs text-gold-light/70 mt-3 flex items-center gap-1" data-id="element-273">
                    <Flame className="w-3 h-3" data-id="element-274" /> Esta oferta no volverá a
                    aparecer fuera de esta página.
                  </p>
                </div>
              </div>
            </div>

            {/* ORDER BUMP #2 */}
            <div className="bg-gold text-white text-center font-bold text-sm md:text-base tracking-wider uppercase py-3 px-6 rounded-t-2xl mb-0" data-id="element-275">
              ⭐ Altamente Recomendado ⭐
            </div>
            <div onClick={() => setBump2(!bump2)} className="order-bump-flash cursor-pointer border-2 border-dashed border-gold rounded-t-none rounded-b-2xl p-5 md:p-6 mb-6 text-left bg-white/10 hover:bg-white/15 transition-colors" data-id="element-276">
              <div className="flex items-start gap-4" data-id="element-277">
                <div className={`w-6 h-6 mt-1 flex-shrink-0 rounded border-2 flex items-center justify-center transition-colors ${bump2 ? 'bg-gold border-gold' : 'border-gold-light'}`} data-id="element-278">
                  {bump2 && <Check className="w-4 h-4 text-white" data-id="element-279" />}
                </div>
                <div className="flex-1" data-id="element-280">
                  <div className="flex items-center gap-2 mb-3" data-id="element-281">
                    <Flame className="w-5 h-5 text-gold-light" data-id="element-282" />
                    <h4 className="font-bold text-base md:text-lg text-gold-light" data-id="element-283">
                      📸 ¡SÍ! QUIERO EL KIT DE MARKETING "VENTA INSTANTÁNEA"
                      <span className="text-white ml-1" data-id="element-284">($10.900)</span>
                    </h4>
                  </div>
                  <div className="flex flex-col md:flex-row gap-4" data-id="element-285">
                    <img src="https://cdn.magicpatterns.com/uploads/pHS2At3BCCYbqiTNARDvo4/ORDER_BUMP_2.jpg" alt="Kit de Marketing Venta Instantánea" className="w-full md:w-36 h-auto rounded-lg object-cover flex-shrink-0" data-id="element-286" />
                    <p className="text-sm opacity-90 leading-relaxed" data-id="element-287">
                      Dejá de romperte la cabeza pensando qué publicar. Llevate
                      plantillas de Canva 100% editables diseñadas para vender
                      postres, guiones de WhatsApp que cierran ventas en
                      automático. Incluye el{' '}
                      <strong className="text-white" data-id="element-288">
                        "Calendario de 7 días"
                      </strong>{' '}
                      para generar tus primeros pedidos usando solo tus
                      historias de Instagram.{' '}
                      <strong className="text-white" data-id="element-289">
                        (Ahorrá 10 horas de diseño al mes).
                      </strong>
                    </p>
                  </div>
                  <p className="text-xs text-gold-light/70 mt-3 flex items-center gap-1" data-id="element-290">
                    <Flame className="w-3 h-3" data-id="element-291" /> Esta oferta no volverá a
                    aparecer fuera de esta página.
                  </p>
                </div>
              </div>
            </div>

            {/* RESUMEN DE COMPRA */}
            <div className="bg-white/10 border border-gold/30 rounded-2xl p-6 mb-8 text-left" data-id="element-292">
              <h4 className="text-center font-bold text-gold-light text-lg mb-4 font-serif" data-id="element-293">
                🧾 Resumen de tu pedido
              </h4>
              <div className="space-y-3 text-sm" data-id="element-294">
                <div className="flex justify-between items-center border-b border-white/10 pb-3" data-id="element-295">
                  <span className="opacity-90" data-id="element-296">
                    📦 El Paso a Paso del Medio Millón (4 Ebooks PDF + 3 Bonos)
                  </span>
                  <span className="font-bold text-white" data-id="element-297">
                    ${formatPrice(basePrice)}
                  </span>
                </div>
                <div className={`flex justify-between items-center border-b border-white/10 pb-3 transition-all duration-300 ${bump1 ? 'opacity-100' : 'opacity-40'}`} data-id="element-298">
                  <span className="flex items-center gap-2" data-id="element-299">
                    {bump1 ? <Check className="w-4 h-4 text-green-400" data-id="element-300" /> : <X className="w-4 h-4 text-white/40" data-id="element-301" />}
                    Calculadora de Costos Inteligente
                  </span>
                  <span className={`font-bold ${bump1 ? 'text-white' : 'text-white/40 line-through'}`} data-id="element-302">
                    ${formatPrice(bump1Price)}
                  </span>
                </div>
                <div className={`flex justify-between items-center border-b border-white/10 pb-3 transition-all duration-300 ${bump2 ? 'opacity-100' : 'opacity-40'}`} data-id="element-303">
                  <span className="flex items-center gap-2" data-id="element-304">
                    {bump2 ? <Check className="w-4 h-4 text-green-400" data-id="element-305" /> : <X className="w-4 h-4 text-white/40" data-id="element-306" />}
                    Kit de Marketing "Venta Instantánea"
                  </span>
                  <span className={`font-bold ${bump2 ? 'text-white' : 'text-white/40 line-through'}`} data-id="element-307">
                    ${formatPrice(bump2Price)}
                  </span>
                </div>
                <div className="flex justify-between items-center pt-2 text-lg" data-id="element-308">
                  <span className="font-bold text-gold-light" data-id="element-309">
                    TOTAL A PAGAR:
                  </span>
                  <span className="font-bold text-2xl text-white transition-all duration-300" data-id="element-310">
                    ${formatPrice(totalPrice)} ARS
                  </span>
                </div>
              </div>
            </div>

            <CTAButton href={getCheckoutUrl()} external={true} className="w-full md:w-auto mx-auto text-xl py-6 px-12 mb-6 mt-2" data-id="element-311">
              🛒 COMPLETAR MI COMPRA — ${formatPrice(totalPrice)} ARS
            </CTAButton>

            <p className="text-lg font-bold text-gold-light mb-8" data-id="element-312">
              Acceso inmediato tras el pago. Empezás a vender HOY mismo.
            </p>

            <div className="flex flex-wrap justify-center gap-6 text-sm opacity-80 border-t border-white/10 pt-8" data-id="element-313">
              <div className="flex items-center gap-2" data-id="element-314">
                <Lock className="w-4 h-4" data-id="element-315" /> Pago 100% seguro
              </div>
              <div className="flex items-center gap-2" data-id="element-316">
                <Smartphone className="w-4 h-4" data-id="element-317" /> Acceso instantáneo
              </div>
              <div className="flex items-center gap-2" data-id="element-318">
                <RotateCcw className="w-4 h-4" data-id="element-319" /> Garantía 7 días
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* BLOQUE 10 — FAQ */}
      <section className="py-20 px-4 max-w-3xl mx-auto" data-id="element-320">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-chocolate" data-id="element-321">
          Preguntas Frecuentes
        </h2>
        <div className="space-y-4" data-id="element-322">
          {faqs.map((faq, i) => <div key={i} className="bg-white rounded-xl border border-gold/20 overflow-hidden shadow-sm" data-id="element-323">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-cream/50 transition-colors" onClick={() => setOpenFaq(openFaq === i ? null : i)} data-id="element-324">
                <span className="font-bold text-lg text-chocolate pr-4" data-id="element-325">
                  {faq.q}
                </span>
                {openFaq === i ? <ChevronUp className="w-6 h-6 text-gold flex-shrink-0" data-id="element-326" /> : <ChevronDown className="w-6 h-6 text-gold flex-shrink-0" data-id="element-327" />}
              </button>
              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openFaq === i ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-328">
                <p className="text-warm-dark leading-relaxed" data-id="element-329">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </section>

      {/* FOOTER */}
      <footer className="py-8 text-center text-warm-dark/60 text-sm bg-cream" data-id="element-330">
        <p className="mb-3" data-id="element-331">
          © {new Date().getFullYear()} El Paso a Paso del Medio Millón. Todos
          los derechos reservados.
        </p>
        <div className="flex items-center justify-center gap-4" data-id="element-332">
          <button onClick={() => setModal('privacy')} className="underline hover:text-gold transition-colors" data-id="element-333">
            Política de Privacidad
          </button>
          <span data-id="element-334">·</span>
          <button onClick={() => setModal('terms')} className="underline hover:text-gold transition-colors" data-id="element-335">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      {/* LEGAL MODAL */}
      {modal && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm" onClick={() => setModal(null)} data-id="element-336">
          <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8 relative shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-337">
            <button onClick={() => setModal(null)} className="absolute top-4 right-4 text-warm-dark/60 hover:text-gold transition-colors" aria-label="Cerrar" data-id="element-338">
              <XIcon className="w-6 h-6" data-id="element-339" />
            </button>

            {modal === 'privacy' && <div className="space-y-4 text-warm-dark" data-id="element-340">
                <h2 className="text-2xl font-bold text-chocolate mb-6" data-id="element-341">
                  Política de Privacidad
                </h2>
                <p data-id="element-342">
                  <strong data-id="element-343">Última actualización:</strong> Abril 2026
                </p>
                <p data-id="element-344">
                  En El Paso a Paso del Medio Millón, nos comprometemos a
                  proteger tu privacidad. Esta política describe cómo
                  recopilamos, usamos y protegemos tu información personal.
                </p>
                <h3 className="text-lg font-bold text-chocolate pt-2" data-id="element-345">
                  1. Información que recopilamos
                </h3>
                <p data-id="element-346">
                  Recopilamos únicamente la información necesaria para procesar
                  tu compra: nombre, dirección de correo electrónico y datos de
                  pago. No almacenamos datos de tarjetas de crédito en nuestros
                  servidores.
                </p>
                <h3 className="text-lg font-bold text-chocolate pt-2" data-id="element-347">
                  2. Uso de la información
                </h3>
                <p data-id="element-348">
                  Tu información se utiliza exclusivamente para: procesar tu
                  pedido, enviarte el producto digital adquirido y comunicarnos
                  contigo respecto a tu compra.
                </p>
                <h3 className="text-lg font-bold text-chocolate pt-2" data-id="element-349">
                  3. Protección de datos
                </h3>
                <p data-id="element-350">
                  Implementamos medidas de seguridad técnicas y organizativas
                  para proteger tu información personal contra acceso no
                  autorizado, alteración o destrucción.
                </p>
                <h3 className="text-lg font-bold text-chocolate pt-2" data-id="element-351">
                  4. Terceros
                </h3>
                <p data-id="element-352">
                  No vendemos, intercambiamos ni transferimos tu información
                  personal a terceros, excepto a los proveedores de servicios de
                  pago necesarios para completar tu transacción.
                </p>
                <h3 className="text-lg font-bold text-chocolate pt-2" data-id="element-353">
                  5. Tus derechos
                </h3>
                <p data-id="element-354">
                  Podés solicitar acceso, rectificación o eliminación de tus
                  datos personales en cualquier momento.
                </p>
              </div>}

            {modal === 'terms' && <div className="space-y-4 text-warm-dark" data-id="element-355">
                <h2 className="text-2xl font-bold text-chocolate mb-6" data-id="element-356">
                  Términos y Condiciones
                </h2>
                <p data-id="element-357">
                  <strong data-id="element-358">Última actualización:</strong> Abril 2026
                </p>
                <p data-id="element-359">
                  Al adquirir El Paso a Paso del Medio Millón, aceptás los
                  siguientes términos y condiciones de uso.
                </p>
                <h3 className="text-lg font-bold text-chocolate pt-2" data-id="element-360">
                  1. Producto digital
                </h3>
                <p data-id="element-361">
                  Este es un producto digital (Ebook PDF) que se entrega de
                  forma inmediata tras confirmar el pago. Por su naturaleza
                  digital, no se aceptan devoluciones una vez descargado el
                  material.
                </p>
                <h3 className="text-lg font-bold text-chocolate pt-2" data-id="element-362">
                  2. Uso personal
                </h3>
                <p data-id="element-363">
                  El contenido adquirido es para uso personal y exclusivo del
                  comprador. Queda prohibida su reproducción, distribución,
                  reventa o compartición total o parcial sin autorización
                  expresa.
                </p>
                <h3 className="text-lg font-bold text-chocolate pt-2" data-id="element-364">
                  3. Propiedad intelectual
                </h3>
                <p data-id="element-365">
                  Todo el contenido, incluyendo textos, recetas, imágenes,
                  diseños y estrategias, es propiedad intelectual de El Paso a
                  Paso del Medio Millón y está protegido por las leyes de
                  derechos de autor.
                </p>
                <h3 className="text-lg font-bold text-chocolate pt-2" data-id="element-366">
                  4. Resultados
                </h3>
                <p data-id="element-367">
                  Los resultados mencionados son ejemplos ilustrativos. Los
                  ingresos reales dependen del esfuerzo, dedicación y
                  condiciones del mercado de cada persona.
                </p>
                <h3 className="text-lg font-bold text-chocolate pt-2" data-id="element-368">
                  5. Modificaciones
                </h3>
                <p data-id="element-369">
                  Nos reservamos el derecho de modificar estos términos en
                  cualquier momento. Las modificaciones serán efectivas desde su
                  publicación.
                </p>
              </div>}
          </div>
        </div>}
    </div>;
}